import { inputBaseClasses } from '@mui/material/InputBase'
import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  form: {
    fontSize: '14px',
    padding: `${theme.spacing(2)} 0 ${theme.spacing(2)} ${theme.spacing(2)}`,
  },

  section: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'baseline',
    paddingRight: theme.spacing(2),
  },

  sectionLabel: {
    fontFamily: 'Source Sans Pro Bold',
    marginRight: 'auto',
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)} 0`,
    height: '44px',
  },

  subSection: {
    fontSize: '12px',
    margin: `${theme.spacing(-1)} ${theme.spacing(2)} 0 ${theme.spacing(7.8)}`,
    padding: `${theme.spacing(0.7)} ${theme.spacing(0)} ${theme.spacing(
      0.7,
    )} ${theme.spacing(2.5)}`,
    backgroundColor: '#f7f7f7',
    border: '1px solid #c4c4c4',
    borderTop: 'none',
    borderRadius: '0 0 4px 4px',
  },

  textField: { width: '100%' },

  textFieldSquare: {
    [`& .${inputBaseClasses.root}.${inputBaseClasses.disabled}`]: {
      '& fieldset': {
        borderRadius: '4px 4px 0 0',
      },
    },
  },

  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    // margin: '4px 0 auto 0',
  },

  lockIcon: { margin: `0 ${theme.spacing(1.9)}` },
  deleteButton: { margin: `0 ${theme.spacing(1.6)}` },
  smallLockIcon: {
    margin: `0 ${theme.spacing(1.4)} 0 ${theme.spacing(0.3)}`,
  },
  smallDeleteButton: { margin: `0 ${theme.spacing(1.1)} 0 0` },
  smallButton: { fontSize: '12px' },

  draggable: {
    margin: `${theme.spacing(1.2)} ${theme.spacing(2)} ${theme.spacing(2)}`,
    background: theme.palette.common.white,
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px rgb(0 0 0 / 14%), 0px 1px 5px rgb(0 0 0 / 12%)',
    borderRadius: '4px',
  },

  checkboxRoot: { margin: 0 },
  checkboxLabel: { fontSize: '14px' },
  checkboxSubRoot: { marginLeft: theme.spacing(2.5) },
  checkboxNestedSubRoot: { marginLeft: theme.spacing(5) },
  loadingContainer: { display: 'flex' },
  loader: { margin: 'auto' },
  editAlert: { margin: `0 ${theme.spacing(2)} ${theme.spacing(1)} 0` },
})
